// npm install overmind overmind-react
// yarn add overmind overmind-react

import {createOvermind} from "overmind";
import {createHook} from "overmind-react";

export const useOvermind = createHook();
export const overmind = createOvermind({
    state: {
        add: {
            message: ""
        },
        show: {
            message: ""
        },
        link: "",
        showProgress: false,
        snackbarMessage: ""
    },
    actions: {
        setAddObj({state}, obj) {
            state.add = obj
        },
        setShowObj({state}, obj) {
            state.show = obj
        },
        setLink({state}, link) {
            state.link = link
        },
        setShowProgress({state}, b) {
            state.showProgress = b
        },
        setSnackbarMessage({state}, message) {
            state.snackbarMessage = message
        }
    }
});
